export const limiter = (value: string, setter: (K: string) => void, limit: number) => {
  if (value.length <= limit) {
    setter(value);
  }
};
